import { isArray } from 'lodash';
import React from 'react';
import style from './Breadcrumbs.scss';
var Breadcrumbs = function (_a) {
    var children = _a.children;
    children = isArray(children) ? children : [children];
    return React.createElement("ul", { className: style.breadcrumbs }, children.map(function (child, index) { return (React.createElement("li", { key: index }, child)); }));
};
export default Breadcrumbs;
